import { PureComponent } from 'react';
import { ConnectedProps, connect } from 'react-redux';

import { setGMapsError } from 'modules/main/store/ducks/gMapsError.actions';
import { isBrowser } from 'utils/browser';

type Props = PropsFromRedux;

class SetGMapsError extends PureComponent<Props> {
  componentDidMount() {
    if (isBrowser()) {
      // @ts-expect-error TS(2339): Property 'setGMapsError' does not exist on type '{... Remove this comment to see the full error message
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      window.Idealist.setGMapsError = (errorType: any) => {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        this.props.setGMapsError(errorType);
      };
    }

    // @ts-expect-error TS(2339): Property 'gmapsErrors' does not exist on type '{ i... Remove this comment to see the full error message
    if (Array.isArray(window.Idealist.gmapsErrors)) {
      // @ts-expect-error TS(2339): Property 'gmapsErrors' does not exist on type '{ i... Remove this comment to see the full error message
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      window.Idealist.gmapsErrors.forEach((errorType: any) => {
        // @ts-expect-error TS(2339): Property 'setGMapsError' does not exist on type '{... Remove this comment to see the full error message
        window.Idealist.setGMapsError(errorType);
      });
    }
  }

  render() {
    return null;
  }
}

const connector = connect(null, { setGMapsError });

type PropsFromRedux = ConnectedProps<typeof connector>;

// eslint-disable-next-line import/no-default-export
export default connector(SetGMapsError);
